import { Loader } from '@googlemaps/js-api-loader';

export const googleLoader = new Loader({
  apiKey: 'AIzaSyCwOoA_Kyj7UTFjml8UP1KCNa8mMCXEfBA',
  version: 'weekly',
  libraries: ['maps', 'marker', 'places'],
});
